import { InjectionToken } from '@angular/core';
import { SubmissionDocument, SubmissionDocumentTypesList } from '../types';

export const submissionDocumentTypesInitialState: SubmissionDocumentTypesList = {
  attributes: [],
  canCloseDialog: false,
  data: [],
  documentTypes: [],
  entity_type: "",
  error: null,
  isLoading: false,
  lastUpdateResult: null,
  submission: {} as SubmissionDocument,
  workspaceTypeId: ""
};

export const SUBMISSION_DOCUMENT_TYPES_INITIAL_STATE = new InjectionToken<SubmissionDocumentTypesList>(
  'Submission Document Types Initial State',
  {
    factory: () => ({ ...submissionDocumentTypesInitialState }),
  },
);
